import { useState } from 'react';
import { Buttons, ChooseSpecificVersions } from 'components';

const ChooseSpecificVersionsBtn = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Buttons.SecondaryNormal
        id='categories'
        style={{ width: '100%' }}
        onClick={() => setIsOpen(true)}
      >
        Choose Versions
      </Buttons.SecondaryNormal>
      {isOpen && (
        <ChooseSpecificVersions close={() => setIsOpen(false)} title='Specific Versions' />
      )}
    </>
  );
};

export default ChooseSpecificVersionsBtn;
